import { CARD_ICONS } from "../../../assets/icons";

export function PaymentDetails({ paymentMethod, order }) {
  if (!paymentMethod || !order?.charge) return null;

  const billingDetails = paymentMethod.billing_details;
  const card = paymentMethod.card;
  const charge = order.charge;

  const totalCharge = `$${charge.amount} ${charge.currency.toUpperCase()}`;

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 sm:p-8">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <h3 className="text-lg font-semibold text-gray-900">
          Payment Details
        </h3>
        <div className="flex-1 border-t border-gray-200" />
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {/* Billing Address */}
        <div className="rounded-xl border border-gray-200 p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">
              Billing Address
            </span>
            <div className="flex-1 border-t border-gray-200" />
          </div>

          <div className="text-sm space-y-1 text-gray-700">
            {billingDetails?.name && (
              <div className="font-medium text-gray-900">
                {billingDetails.name}
              </div>
            )}
            {billingDetails?.address?.line1 && (
              <div>{billingDetails.address.line1}</div>
            )}
            {billingDetails?.address?.line2 && (
              <div>{billingDetails.address.line2}</div>
            )}
            {(billingDetails?.address?.city ||
              billingDetails?.address?.state) && (
              <div className="text-gray-600">
                {billingDetails.address.city}
                {billingDetails.address.city &&
                billingDetails.address.state
                  ? ", "
                  : ""}
                {billingDetails.address.state}
              </div>
            )}
            {billingDetails?.address?.postal_code && (
              <div className="text-gray-600">
                {billingDetails.address.postal_code}
              </div>
            )}
            {billingDetails?.address?.country && (
              <div className="text-gray-600">
                {billingDetails.address.country}
              </div>
            )}
          </div>
        </div>

        {/* Card Info */}
        <div className="rounded-xl border border-gray-200 p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">
              Payment Method
            </span>
            <div className="flex-1 border-t border-gray-200" />
          </div>

          <div className="flex items-center gap-4">
            <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-slate-100 text-[#0052FF]">
              {CARD_ICONS[card.brand]}
            </div>

            <div className="flex flex-col">
              <span className="text-sm font-medium text-gray-900">
                **** **** **** {card.last4}
              </span>
              <span className="text-xs text-gray-500">
                Expires {card.exp_month}/{card.exp_year}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Total */}
      <div className="mt-6 pt-4 border-t border-gray-200 flex items-center justify-between">
        <span className="text-sm font-medium text-gray-600">
          Order Total
        </span>
        <span className="text-xl font-semibold text-gray-900">
          {totalCharge}
        </span>
      </div>
    </div>
  );
}